import React from 'react'
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom'

import WebglRender from './pages/webgl/webgl_render.jsx'

export default class ERouter extends React.Component {

    render() {
        return (
            <HashRouter>

                <Switch>
                    <Route path="/" render={()=>
                        <Switch>
                            <Route path='/' component={WebglRender} />
                            <Redirect to="/" />
                        </Switch>    
                    } />
                </Switch>

            </HashRouter>
        );
    }
}


// WEBPACK FOOTER //
// ./src/router.js